import { CardList } from './CardList';

export default CardList;
